module.exports = __webpack_public_path__ + "static/img/5.67f0bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/five/5.png
// module id = 2rwC
// module chunks = 1